import { Button } from "components/Button";
import styled from "styled-components";

export const ButtonRefuse = styled(Button)`
  border: 2px solid #E84F4F;

  p {
    color: #E84F4F;
  }
`;